import React from 'react'

const Courses = () => {
  const courses = [
    {
      icon: 'fas fa-calculator',
      title: 'ریاضی ابتدایی ',
      description: 'پایه پنجم ، ششم'
    },
    {
      icon: 'fas fa-shapes',
      title: 'ریاضی متوسطه اول',
      description: 'پایه هفتم ، هشتم ، نهم'
    },
    {
      icon: 'fas fa-square-root-alt',
      title: 'ریاضی دهم',
      description: 'دروس تجربی ، ریاضی ، انسانی ، فنی'
    },
    {
      icon: 'fas fa-chart-line',
      title: 'ریاضی یازدهم',
      description: 'دروس تجربی ، انسانی ، فنی'
    },
    {
      icon: 'fas fa-infinity',
      title: 'ریاضی دوازدهم',
      description: 'دروس تجربی ، انسانی ، فنی'
    },
    {
      icon: 'fas fa-brain',
      title: 'علوم و عربی',
      description: 'پایه هفتم ، هشتم ، نهم'
    },
  ]

  return (
    <section id="courses" className="courses">
      <div className="container">
        <h2 className="section-title">دروس من</h2>
        <div className="courses-grid">
          {courses.map((course, index) => (
            <div key={index} className="course-card card-base card-light-sweep card-overlay">
              <div className="course-icon">
                <i className={course.icon} aria-hidden="true"></i>
              </div>
              <h3>{course.title}</h3>
              <p>{course.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Courses 